import service from '../../config/axios.config';

export const fetchManagerialDecisions = () =>
  service.get(`managerialDecisions`);

export const approveManagerialDecision = id =>
  service.put(`managerialDecisions/${id}/approve`);